import { Box, CircularProgress } from '@mui/material'
import React from 'react'
import logo from '../resources/loader.svg'
import { Helmet } from 'react-helmet-async'

const Loader = () => {
  return (
    <>
      <Helmet>
        <title>Home | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <img src={logo} alt="logo" style={{ width: '32px' }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            position: 'absolute',
          }}
        >
          <CircularProgress size={60} thickness={1.5} />
        </Box>
      </Box>
    </>
  )
}

export default Loader
